import { createContext } from 'react';

export const ContextMenuContext = createContext({
    isOpen: false,
    setIsOpen: (_value: boolean) => {},
});
